import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  ROLE_MODELS,
  ROLE_MODEL_QUESTION,
} from '~/pages/communication/roleModel/libs/components/RoleModelCommunication/constants'
import { RoleModelCommunicationStyles as S } from '~/pages/communication/roleModel/libs/components/RoleModelCommunication/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const RoleModelCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('communication')
  const [selected, setSelected] = useState<Set<string>>(new Set())

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: ROLE_MODEL_QUESTION,
  })

  const toggle = (key: string) => {
    setSelected((prev) => {
      const next = new Set(prev)
      if (next.has(key)) {
        next.delete(key)
      } else {
        next.add(key)
      }
      return next
    })
  }

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.Title>
          <Trans
            ns="communication"
            i18nKey="onboarding.communicationRoleModel.title"
          />
        </S.Title>

        <S.Subtitle>
          <Trans
            ns="communication"
            i18nKey="onboarding.communicationRoleModel.subtitle"
          />
        </S.Subtitle>

        <S.AvatarGrid>
          {ROLE_MODELS.map(({ key, name, image }) => (
            <S.AvatarItem key={key}>
              <S.AvatarCircle
                type="button"
                $isSelected={selected.has(key)}
                onClick={() => toggle(key)}
              >
                <img src={image} alt={name} />
              </S.AvatarCircle>
              <S.AvatarName>
                {t(`onboarding.communicationRoleModel.names.${key}`, {
                  defaultValue: name,
                })}
              </S.AvatarName>
            </S.AvatarItem>
          ))}
        </S.AvatarGrid>

        <S.Button
          type="button"
          disabled={selected.size === 0}
          onClick={() => handleContinue(Array.from(selected).join(','))}
        >
          <Trans i18nKey="actions.continue" />
        </S.Button>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default RoleModelCommunication
